var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlikeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 59,
    viewBox: "0 0 56 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4868_1067)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 50,
    height: 52.2222,
    rx: 11.1111,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 49,
    height: 51.2222,
    rx: 10.6111,
    stroke: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2523 15.6016V29.3516M40.5023 25.3516V19.6016C40.5023 18.2014 40.5023 17.5014 40.2298 16.9666C39.9901 16.4962 39.6076 16.1137 39.1372 15.874C38.6025 15.6016 37.9024 15.6016 36.5023 15.6016H23.1498C21.3229 15.6016 20.4095 15.6016 19.6717 15.9359C19.0215 16.2305 18.4689 16.7046 18.0788 17.3025C17.6362 17.9808 17.4973 18.8836 17.2195 20.6892L16.5657 24.9392C16.1993 27.3207 16.0161 28.5114 16.3695 29.438C16.6797 30.2512 17.2631 30.9312 18.0197 31.3614C18.8817 31.8516 20.0864 31.8516 22.4959 31.8516H23.5023C24.2023 31.8516 24.5524 31.8516 24.8198 31.9878C25.055 32.1076 25.2462 32.2989 25.366 32.5341C25.5023 32.8015 25.5023 33.1515 25.5023 33.8516V37.5193C25.5023 39.2216 26.8823 40.6016 28.5846 40.6016C28.9906 40.6016 29.3585 40.3624 29.5234 39.9914L33.7244 30.5393C33.9155 30.1094 34.011 29.8944 34.162 29.7368C34.2955 29.5975 34.4594 29.4909 34.641 29.4255C34.8463 29.3516 35.0815 29.3516 35.552 29.3516H36.5023C37.9024 29.3516 38.6025 29.3516 39.1372 29.0791C39.6076 28.8394 39.9901 28.4569 40.2298 27.9865C40.5023 27.4518 40.5023 26.7517 40.5023 25.3516Z",
    stroke: "#FC7700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4868_1067",
    x: 0.222222,
    y: 0.611111,
    width: 55.5556,
    height: 57.7743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38889
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4868_1067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4868_1067",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlikeButton);
export default __webpack_public_path__ + "static/media/Unlike Button.dacbb49322761ce47fd552ab29b6deac.svg";
export { ForwardRef as ReactComponent };